import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
// Mui
import { Box, Toolbar, Container, Typography } from '@mui/material';
// 
import PackagesList from './PackagesList';
import PackagesFab from './PackagesFab';

const CompanyAccountsPage:FC = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Toolbar variant="dense">
        <Typography variant="h6">{t('pages.subscriptionPackages.title')}</Typography>
      </Toolbar>
      <Box sx={{ flexGrow: 1, overflowY: 'auto' }} react-action="scroll">
        <Container sx={{ pt: 4, pb: 20 }} maxWidth="sm">
          <PackagesList />
        </Container>
      </Box>
      <PackagesFab />
    </Fragment>
  )
}

export default CompanyAccountsPage;
